<script setup>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import { ref, computed,onUnmounted } from 'vue';
import { useStore } from 'vuex'
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import axios from 'axios';
import { authHeader } from '@/helpers/authservice/auth-header';
import Swal from 'sweetalert2';

dayjs.extend(localizedFormat)

onUnmounted(() => {
  edit_or.value = null;
  edit_or_search_input.value = '';
})

const title = ref('Edit OR');
const items = ref([
  {
    text: "Home",
  },
    {
    text: "Payment",
  },
  {
    text: "Edit OR",
    active: true,
  },
]);

const store = useStore();
const loading = computed(() => store.state.globals.loading);
const notification = computed(() => store ? store.state.notification : null);

const edit_or = computed({
  get:() => store.state.payment.edit_or,
  set:(val) => store.commit('payment/SET_EDIT_OR',val)
});
const edit_or_search_input = computed({
  get:() => store.state.payment.edit_or_search_input,
  set:(val) => store.commit('payment/SET_EDIT_OR_SEARCH_INPUT',val)
});

const getEditOR = () => store.dispatch('payment/getEditOR');
store.dispatch('notification/clear', null, { root: true });

const search = async () =>{
  edit_or.value = null;
  await getEditOR();
  if(edit_or.value){
    new_or_number_input.value = edit_or.value.number
    new_amount_input.value = edit_or.value.amount
    date_of_payment_input.value = dayjs(edit_or.value.payment_date).format('YYYY-MM-DDTHH:mm')
  }
}

const new_or_number_input = ref('');
const date_of_payment_input = ref('');
const new_amount_input = ref('');
const note = ref('');

const updateOR = async () =>{
  const confirm = await Swal.fire({
    icon: 'warning',
    title: 'Continue?',
    text: 'Do you want to save this data?',
    showCancelButton: true,
    confirmButtonText: 'Proceed',
  })

  if (!confirm.isConfirmed) {
    return;
  }

  store.dispatch('globals/loading', null, { root: true });
  store.dispatch('notification/clear', null, { root: true });
  try {
    let inputs = {
      _method:"PUT",
      number: new_or_number_input.value,
      amount: new_amount_input.value,
      remarks: note.value,
      date_of_payment: date_of_payment_input.value ? dayjs(date_of_payment_input.value).format('YYYY/MM/DD HH:mm') : ''
    }
    console.log(inputs);
    await axios.post(`/payment/official_receipt/${edit_or.value.id}`,inputs,{
        headers: authHeader()
    })

    edit_or_search_input.value = new_or_number_input.value;
    await getEditOR();
    note.value=''

    store.dispatch('globals/loaded', null, { root: true });
  } catch (error) {
    if (error.response) {
        const { message } = error.response.data;
        store.dispatch('notification/error', message, { root: true });
    }
    store.dispatch('globals/loaded', null, { root: true });
  }

}

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-3">
          <b-overlay :show="loading">
            <div class="card">
              <div class="card-header">
                <div class="form-group">
                  <label for="search">Search OR #</label>
                  <input type="text" class="form-control" id="search" autofocus v-model="edit_or_search_input" @keyup.enter="search">
                  <button class="btn w-100 btn-primary mt-1" @click="search">Search</button>
                </div>
              </div>
            </div>
          </b-overlay>
        </div>
        <div class="col-9">
          <b-alert v-if="notification && notification.message"
              show :variant="notification.type" class="fade show" role="alert">
              {{ notification.message }}
          </b-alert>
          <b-overlay :show="loading">
            <div class="card" v-if="edit_or">
              <div class="card-header">
               <table class="table table-bordered m-0">
                  <tbody>
                    <tr>
                      <td style="width:300px">OVR #</td>
                      <td>{{edit_or.ovr_number}}</td>
                    </tr>
                    <tr>
                      <td>Current OR #</td>
                      <td>{{edit_or.number}}</td>
                    </tr>
                    <tr>
                      <td>Current Amount</td>
                      <td>{{edit_or.amount}}</td>
                    </tr>
                    <tr>
                      <td>Date of payment</td>
                      <td>{{dayjs(edit_or.payment_date).format('LLL')}}</td>
                    </tr>
                  </tbody>
                </table>
                <form @submit.prevent="updateOR">
                  <table class="table table-bordered m-0 mt-2">
                    <tbody>
                      <tr>
                        <td style="width:300px">New OR #</td>
                        <td><input type="text" required class="form-control" v-model="new_or_number_input"></td>
                      </tr>
                      <tr>
                        <td>Date of payment</td>
                        <td><input type="datetime-local" required class="form-control" v-model="date_of_payment_input"></td>
                      </tr>
                      <tr>
                        <td>New Amount</td>
                        <td><input type="number" required class="form-control" v-model="new_amount_input"></td>
                      </tr>
                      <tr>
                        <td>Note</td>
                        <td><textarea class="form-control" rows="3" v-model="note"></textarea></td>
                      </tr>
                      <tr>
                        <td colspan="2" class="text-center"><button type="submit" class="btn btn-primary">Update</button></td>
                      </tr>
                    </tbody>
                  </table>
                </form>
                <table class="table table-bordered  m-0 mt-2">
                  <tbody>
                    <tr>
                      <th>Logs</th>
                    </tr>
                    <tr>
                      <th>OR #</th>
                      <th>Amount</th>
                      <th>User</th>
                      <th>Note</th>
                      <th>Date</th>
                    </tr>
                      <template v-if="edit_or.official_receipt_log.length">
                      <tr v-for="log in edit_or.official_receipt_log" :key="log.id">
                        <td style="width:25%">
                          <table class="table table-bordered m-0 mt-2">
                            <tbody>
                              <tr>
                              <td>OLD OR # {{log.old_number}}</td>
                              </tr>
                              <tr>
                              <td>NEW OR # {{log.new_number}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td style="width:25%">
                          <table class="table table-bordered m-0 mt-2">
                            <tbody>
                              <tr>
                              <td>OLD Amount {{log.old_amount}}</td>
                              </tr>
                              <tr>
                              <td>NEW Amount {{log.new_amount}}</td>
                              </tr>
                            </tbody>
                          </table></td>
                        <td style="width:15%">{{log.user_name}}</td>
                        <td>{{log.remarks}}</td>
                        <td style="width:15%">{{dayjs(log.new_payment_date).format('LLL')}}</td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td>No Logs Available</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </b-overlay>
        </div>
      </div>
    </div>
  </Layout>
</template>
